<a-center-container-scrollable>
  <div a-popup [class]="className" (close)="onClose()" [title]="title">
    <ng-content></ng-content>
  </div>
</a-center-container-scrollable>
<div class="overlay" (click)="onClose()"></div>
